import React from 'react';
import "./Footer.css";

const Footer = () => {
    return (
        <div className='footer-container'>
            <h1>© Arabites</h1>
            <p>Your favorite place to learn Arabic</p>
        </div>
    );
};

export default Footer;